import { noop } from 'lodash-es';
import React from 'react';
import { IconButton } from '@components/iconButton/IconButton';
import { type RestaurantEventImage } from '@shared/types/restaurants';
import { getRestaurantImagePath } from '@shared/utils/getRestaurantImagePath';
import styles from './ImageGalleryPreview.scss';

type ImageData = Pick<RestaurantEventImage, 'imageKey'>;

interface ImageGalleryPreviewProps {
  eventName: string;
  images: ImageData[];
  maxImages?: number;
  isEditing?: boolean;
  onRemoveImage?: (imageKey: string) => void;
}

export const ImageGalleryPreview: React.FC<ImageGalleryPreviewProps> = ({
  eventName,
  images = [],
  maxImages = 1,
  isEditing = false,
  onRemoveImage = () => noop,
}) => {
  const displayImages = images.slice(0, maxImages);
  const firstImage = displayImages[0];

  return (
    <div className={styles.container}>
      {firstImage && (
        <div className={styles.imageWrapper}>
          {isEditing && (
            <IconButton
              ariaLabel="Remove image"
              className={styles.removeImageButton}
              iconClassName={styles.removeImageIcon}
              iconName="close"
              onClick={() => onRemoveImage(firstImage.imageKey)}
            />
          )}
          <img
            src={getRestaurantImagePath(firstImage.imageKey)}
            alt={eventName}
          />
        </div>
      )}
    </div>
  );
};
